// Reitin pituus ja vaativuus tekstinä. Tiedot tulevat palvelimen sisällöstä (backend/app/content_pack.py):
// Pituus on lähteestä. Vaativuus voi olla lähdeluokitus, arvio tai käyttäjän antama.

import { dayFromIso, kmValue } from "./format.js";

/** Lähteen luokitus suomeksi. Avaimet vastaavat palvelimen content_pack.DIFFICULTIES-arvoja. */
export const DIFFICULTY_LABEL = { easy: "Helppo", medium: "Keskivaikea", hard: "Vaativa" };

/** Vaativuus tekstinä tai tyhjä, jos se on tuntematon (tai tuntematon arvo, jotta uusi arvo ei riko näkymää). */
export const difficultyLabel = (difficulty) => DIFFICULTY_LABEL[difficulty] ?? "";

/** Lyhyt rivi listaan: "4,0 km · Keskivaikea". Tyhjä, kun kumpaakaan ei tiedetä. */
export function routeFacts(route) {
  const parts = [];
  if (route?.source_length_km) parts.push(kmValue(route.source_length_km));
  const label = difficultyLabel(route?.difficulty);
  if (label) parts.push(route.difficulty_source === "estimate" ? `${label} (arvio)` : label);
  return parts.join(" · ");
}

/** Kortin selitys: mistä tiedot ovat ja milloin ne on tarkistettu. Tyhjä, kun tietoja ei ole. */
export function routeSourceNote(route) {
  if (!route?.source_length_km && !difficultyLabel(route?.difficulty)) return "";
  const checked = /^\d{4}-\d{2}-\d{2}$/.test(route.checked_at ?? "") ? `, tarkistettu ${dayFromIso(route.checked_at)}` : "";
  const facts = [];
  if (route.source_length_km) facts.push("Pituus lähteen ilmoittamana");
  if (difficultyLabel(route.difficulty)) {
    facts.push(route.difficulty_source === "source" ? "vaativuus lähteen luokituksena"
      : route.difficulty_source === "estimate" ? "vaativuus on arvio"
        : route.difficulty_source === "user" ? "vaativuus käyttäjän antamana" : "vaativuuden alkuperää ei ole määritelty");
  }
  const text = facts.join("; ");
  return `${text[0].toUpperCase()}${text.slice(1)}${checked}.`;
}

